import { TimebandService } from 'src/app/angularJS/services/timebands/timeband.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { JourneyConstructionRuleService } from 'src/app/angularJS/services/journey-construction-rule/journey-construction-rule.service';

/**
* A method that sets up the routes for this module
*/
export const initialise = () => {
  angular.module('app.abt-configuration').config([
    '$stateProvider',
    '$urlRouterProvider',
    '$locationProvider',
    ($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.hashPrefix('');

    $stateProvider.state('journey-construction-rules', {
      url: '/journey-construction-rules',
      templateUrl: 'app/angularJS/features/abt/abt-configuration/journey-construction-rules/journey-construction-rules.html',
      controller: 'JourneyConstructionRulesController',
      controllerAs: 'vm',
      parent: 'common'
    }).state('journey-construction-rule-manage', {
      url: '/journey-construction-rule-manage/:id',
      templateUrl: 'app/angularJS/features/abt/abt-configuration/journey-construction-rules/manage-rule/journey-construction-rule-manager.html',
      controller: 'JourneyConstructionRuleManagerController',
      controllerAs: 'vm',
      parent: 'common',
      resolve: {
        journeyConstructionRule: getJourneyConstructionRule
      },
      params: {
        id: ''
      }
    }).state('view-timebands', {
      url: '/timebands',
      templateUrl: 'app/angularJS/features/abt/abt-configuration/timebands/timebands.html',
      controller: 'TimebandsController',
      controllerAs: 'vm',
      parent: 'common',
      resolve: {
        timebandsResponse: getTimebands
      }
    }).state('timeband-manager', {
      url: '/timeband/manage/:timebandId',
      templateUrl: 'app/angularJS/features/abt/abt-configuration/timebands/manage-timeband/timeband-manager.html',
      controller: 'ManageTimebandController',
      controllerAs: 'vm',
      parent: 'common',
      resolve: {
        timeband: getTimeband
      }
    }).state('special-days', {
      url: '/special-days',
      templateUrl: 'app/angularJS/features/abt/abt-configuration/special-days/special-days.html',
      controller: 'SpecialDaysController',
      controllerAs: 'vm',
      parent: 'common'
    });

    $urlRouterProvider.otherwise('/');
  }]);

  getTimeband.$inject = [
    'timebandService',
    '$stateParams',
    'QueryBuilder',
    'userService',
    'LinkBuilder',
    '$q'];
  function getTimeband(
    timebandService: TimebandService,
    $stateParams: ng.ui.IStateParamsService,
    queryBuilder: QueryBuilder,
    userService: UserService,
    linkBuilder: LinkBuilder,
    $q: ng.IQService) {
    if (!$stateParams.timebandId) {
      const newTimeband = {
        scheme: {
          link: undefined,
          abbreviation: undefined
        },
        name: '',
        startTime: '04:00',
        endTime: '23:59',
        dayOfWeek: [],
        timeBandApplication: 'USAGE_START'
      };

      if (!userService.selectedSchemes || userService.selectedSchemes.length === 0) {
        const deferred = $q.defer();
        const callbackRef = userService.registerSchemeCallback(() => {
          userService.unregisterCallback(callbackRef);
          newTimeband.scheme.link = linkBuilder.getSchemesLink(userService.selectedScheme.id);
          newTimeband.scheme.abbreviation = userService.selectedScheme.reference;
          deferred.resolve(newTimeband);
        });

        return deferred.promise;
      } else {
        newTimeband.scheme.link = linkBuilder.getSchemesLink(userService.selectedScheme.id);
        newTimeband.scheme.abbreviation = userService.selectedScheme.reference;
        return newTimeband;
      }
    } else {
      const query = queryBuilder.newParam().fieldIs('id', $stateParams.timebandId).getParam();

      return timebandService.getList(1, 1, query).then((response) => {
        return response.timebands.length > 0 ? response.timebands[0].timeband : undefined;
      });
    }
  }

  getTimebands.$inject = ['timebandService'];
  function getTimebands(timebandService: TimebandService) {
    return timebandService.getList(1, 15, 'sortBy created desc');
  }

  getJourneyConstructionRule.$inject = [
    '$q',
    '$stateParams',
    'journeyConstructionRuleService',
    'QueryBuilder'
  ];
  function getJourneyConstructionRule(
    $q: ng.IQService,
    $stateParams: ng.ui.IStateParamsService,
    journeyConstructionRuleService: JourneyConstructionRuleService,
    QueryBuilder: QueryBuilder) {
    const deferred = $q.defer();

    if (!$stateParams.id) {
      return deferred.resolve(undefined);
    }

    const query = QueryBuilder.newParam().fieldIs('id', $stateParams.id).getParam();
    journeyConstructionRuleService.getList(1, 1, query).then((response) => {
      if (response.journeyConstructionRules.length === 0) {
        return deferred.resolve(undefined);
      }

      deferred.resolve(response.journeyConstructionRules[0].journeyConstructionRule);
    });

    return deferred.promise;
  }
}